module.exports = __webpack_public_path__ + "static/mac-31b245e9d10146f1919c236303ec8585.jpg";